import { createApp } from 'vue'
import { loadFonts } from './plugins/webfontloader'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import VueSplide from '@splidejs/vue-splide'

// Views
import Home from './views/Home.vue'
import Products from './views/Products.vue'
import About from './views/About.vue'
//import Shop from './views/Shop.vue'
import Contact from './views/Contact.vue'
import Impressum from './views/Impressum.vue'
import Datenschutz from './views/Datenschutz.vue'
import Leistungen from './views/Leistungen.vue'
import LocationLanding from './views/LocationLanding.vue'
import ServiceArea from './views/ServiceArea.vue'
import locationData from './locationData.json'


// Styles
import './main.css'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);


loadFonts()

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: Home, meta: { title: 'Schreinerei M²' } },
    { path: '/products', component: Products, meta: { title: 'Arbeiten | Schreinerei M²' } },
    { path: '/about', component: About, meta: { title: 'Über uns | Schreinerei M²' } },
    //{ path: '/shop', component: Shop },
    { path: '/contact', component: Contact, meta: { title: 'Kontakt | Schreinerei M²' } },
    { path: '/leistungen', component: Leistungen, meta: { title: 'Leistungen | Schreinerei M²' } },
    { path: '/impressum', component: Impressum, meta: { title: 'Impressum | Schreinerei M²' } },
    { path: '/datenschutz', component: Datenschutz, meta: { title: 'Datenschutz | Schreinerei M²' } },
    { path: '/einzugsgebiet', component: ServiceArea, meta: { title: 'Schreiner Region Reutlingen & Schwäbische Alb | Schreinerei M²' } },
    { path: '/schreiner-:slug', component: LocationLanding, meta: { title: 'Schreinerei M²' } },
  ],
})

router.afterEach((to) => {
  if (to.params.slug) {
    const loc = locationData.find((l) => l.slug === to.params.slug)
    document.title = loc ? 'Schreiner ' + loc.name + ' | Schreinerei M²' : 'Schreinerei M²'
  } else {
    document.title = to.meta.title || 'Schreinerei M²'
  }
})

createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueSplide)
  .mount('#app')
